'use strict';
/*
* partner list more button
* @package krobot
* @deps jquery
*/
const $ = jQuery;

const visibleItemNum = 6;
$( '.krobot-partners-list__item:nth-child(n + ' + ( visibleItemNum + 1 ) + ')' ).addClass( 'pre-hidden' );
$( '.js-partners-more' ).on( 'click keypress', function() {
	$( '.pre-hidden:not(.active)' ).slice( 0, visibleItemNum ).addClass( 'active' );
	if ( $( '.krobot-partners-list__item.pre-hidden:not(.active)' ).length === 0 ) {
		$( '.krobot-partners-list__more' ).addClass( 'off' );
	}
} );
